export function Equal(wrap, elem, width = 0) {
    if (jQuery(wrap).length > 0) {
        jQuery(wrap).find(elem).css('height', '')

        if (jQuery(window).width() > width) {
            jQuery(wrap).each(function () {
                let highest = 0;
                let el      = jQuery(this).find(elem);

                el.each(function () {
                    const height = jQuery(this).height();
                    if (height > highest) {
                        highest = height;
                    }
                });

                el.height(highest);
            });
        }
    }
}